import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { waLink } from "../data/site";

const useHidden = () => {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const seen = new Set();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)));
      setHidden(seen.size > 0);
    }, { threshold: 0.05 });
    document.querySelectorAll("[data-hide-wa]").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
  return hidden;
};

export const WhatsAppFloat = () => {
  const hidden = useHidden();
  return (
  <AnimatePresence>
  {!hidden && (
  <motion.a
    href={waLink("Olá, Alfa Gráfica Digital! Gostaria de solicitar um orçamento.")}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Falar no WhatsApp"
    data-testid="whatsapp-float-btn"
    initial={{ opacity: 0, scale: 0.6, y: 20 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    exit={{ opacity: 0, scale: 0.6, y: 20 }}
    transition={{ type: "spring", stiffness: 260, damping: 20 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.92 }}
    className="group fixed bottom-4 right-4 sm:bottom-8 sm:right-8 z-[60] flex items-center gap-3"
  >
    <span className="hidden sm:block rounded-full bg-ink text-paper text-xs font-bold uppercase tracking-wide px-4 py-2 opacity-0 translate-x-2 transition-[opacity,transform] duration-300 group-hover:opacity-100 group-hover:translate-x-0">
      Fale com a gente
    </span>
    <span className="relative grid place-items-center h-12 w-12 sm:h-16 sm:w-16 rounded-full bg-alga text-paper shadow-[0_0_28px_rgba(255,90,0,0.6)]">
      <span className="absolute inset-0 rounded-full bg-alga animate-ping opacity-30" />
      <svg viewBox="0 0 24 24" className="relative h-6 w-6 sm:h-8 sm:w-8" fill="currentColor" aria-hidden="true">
        <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.62.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35M12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.56.93.95-3.47-.22-.36a9.4 9.4 0 0 1-1.44-5.01c0-5.2 4.23-9.43 9.44-9.43 2.52 0 4.89.98 6.67 2.77a9.37 9.37 0 0 1 2.76 6.67c0 5.2-4.23 9.43-9.44 9.43m8.03-17.46A11.27 11.27 0 0 0 12.05.7C5.79.7.7 5.79.7 12.05c0 2 .52 3.95 1.52 5.67L.6 23.6l6.02-1.58a11.33 11.33 0 0 0 5.42 1.38h.01c6.26 0 11.35-5.09 11.35-11.35 0-3.03-1.18-5.88-3.32-8.02" />
      </svg>
    </span>
  </motion.a>
  )}
  </AnimatePresence>
  );
};
